import React from 'react';
import { Dialog, Transition } from '@headlessui/react';
import { Fragment } from 'react';

const ConfirmationModal = ({ 
    isOpen, 
    onClose, 
    title = '',
    message = '',
    confirmText = 'OK',
    cancelText = 'Cancel',
    onConfirm
}) => {
    const handleConfirm = () => {
        if (onConfirm) {
            onConfirm();
        }
        onClose();
    };

    const handleCancel = () => {
        onClose();
    };

    return (
        <Transition appear show={isOpen} as={Fragment}>
            <Dialog as="div" className="relative z-50" onClose={handleCancel}>
                <Transition.Child
                    as={Fragment}
                    enter="ease-out duration-300"
                    enterFrom="opacity-0"
                    enterTo="opacity-100"
                    leave="ease-in duration-200"
                    leaveFrom="opacity-100"
                    leaveTo="opacity-0"
                >
                    <div className="fixed inset-0 bg-black bg-opacity-60 backdrop-blur-sm" />
                </Transition.Child>

                <div className="fixed inset-0 overflow-y-auto">
                    <div className="flex min-h-full items-center justify-center p-4 text-center">
                        <Transition.Child
                            as={Fragment}
                            enter="ease-out duration-300"
                            enterFrom="opacity-0 scale-95"
                            enterTo="opacity-100 scale-100"
                            leave="ease-in duration-200"
                            leaveFrom="opacity-100 scale-100"
                            leaveTo="opacity-0 scale-95"
                        >
                            <Dialog.Panel className="w-full max-w-[400px] mx-auto transform overflow-hidden rounded-lg bg-black border border-[rgba(255,255,255,0.1)] p-6 text-left align-middle shadow-xl transition-all">
                                
                                {/* Header */}
                                <div className="flex items-center justify-between mb-6">
                                    <Dialog.Title as="h2" className="text-white text-[14px] font-medium">
                                        {title}
                                    </Dialog.Title>
                                    <span
                                        onClick={handleCancel}
                                        className="text-white text-[12px] font-normal cursor-pointer hover:opacity-70"
                                    >
                                        Close
                                    </span>
                                </div>

                                {/* Message */}
                                <div className="mb-6">
                                    <p className="text-[rgba(255,255,255,0.7)] text-[12px] leading-[1.4] text-left">
                                        {message}
                                    </p>
                                </div>

                                {/* Action Buttons */}
                                <div className="flex justify-end space-x-2 pt-4">
                                    <button
                                        type="button"
                                        className="bg-[#121212] hover:bg-[#1a1a1a] text-white text-[12px] font-medium py-2 px-4 rounded-[8px] transition-colors focus:outline-none"
                                        onClick={handleCancel}
                                    >
                                        {cancelText}
                                    </button>
                                    
                                    <button
                                        type="button"
                                        className="bg-[#FF3B30] hover:bg-[#e63329] text-white text-[12px] font-medium py-2 px-4 rounded-[8px] transition-all focus:outline-none"
                                        onClick={handleConfirm}
                                    >
                                        {confirmText}
                                    </button>
                                </div>
                            </Dialog.Panel>
                        </Transition.Child>
                    </div>
                </div>
            </Dialog>
        </Transition>
    );
};

export default ConfirmationModal;
